var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOtherPlumbing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "other-plumbing",
    fill: "none",
    viewBox: "0 0 42 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26.564 18.592c4.2158 1.2326 7.6801-2.2863 6.1992-6.297l-3.8289 3.8893c-1.9241-0.329-2.51-0.9706-2.7571-2.7143l3.8289-3.8894c-2.8951-1.3913-7.7381 0.77035-6.1992 6.297",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.437 24.17c-4.2158-1.2326-7.6801 2.2863-6.1992 6.2971l3.8289-3.8894c1.9241 0.329 2.51 0.9706 2.7571 2.7143l-3.8289 3.8894c2.8951 1.3913 7.7381-0.7703 6.1992-6.2971",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m26.533 18.56-8.2656 8.3961",
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m23.734 15.806-8.2656 8.396",
    stroke: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m18.211 15.818c1.2327-4.2158-2.2863-7.68-6.297-6.1992l3.8893 3.8289c-0.3289 1.9241-0.9706 2.51-2.7143 2.7572l-3.8893-3.8289c-1.3913 2.895 0.77031 7.738 6.297 6.1992",
    stroke: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m23.789 26.944c-1.2327 4.2158 2.2863 7.68 6.297 6.1992l-3.8893-3.8289c0.3289-1.9241 0.9706-2.51 2.7143-2.7572l3.8893 3.829c1.3913-2.8951-0.7703-7.7381-6.297-6.1992",
    stroke: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m27.012 23.935-2.777-2.777",
    stroke: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m23.542 27.406-2.7771-2.777",
    stroke: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m17.988 21.853-2.7771-2.777",
    stroke: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m21.459 18.382-2.7771-2.777",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherPlumbing);
export default __webpack_public_path__ + "static/media/other-plumbing.8efc7a41b617261c65bbcebd115a9e0d.svg";
export { ForwardRef as ReactComponent };